import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    return (
        <header className="header">
            <div className="container">
                <Link to="/" className="logo">
                    <img src="/ACT.png" alt="ApplicodeTech" className="logo-img" />
                </Link>

                <button
                    className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
                    <Link
                        to="/"
                        className={`nav-link ${isActive('/') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        Accueil
                    </Link>
                    <Link
                        to="/about"
                        className={`nav-link ${isActive('/about') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        À propos
                    </Link>
                    <Link
                        to="/services"
                        className={`nav-link ${isActive('/services') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        Services
                    </Link>
                    <Link
                        to="/blog"
                        className={`nav-link ${isActive('/blog') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        Blog
                    </Link>
                    <Link
                        to="/contact"
                        className="nav-link nav-cta"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        Contact
                    </Link>
                </nav>
            </div>
        </header>
    );
}